import { createPinia } from "pinia";

export default function pinaMakeStore() {
  const pinia = createPinia();
  return pinia;
}
